import digitalAssaysUser from "../sampleData/me.json";
import sessionUser from "../sampleData/sessionUser.json";
import axios from "axios";
import * as config from "../app.config";
import { encrypt } from "../util/format";

const USERAPI = `${config.ENDPOINTS.main}/v1/user`;

export const FETCHING_SESSION = "FETCHING_SESSION";
export const FETCH_COOKIE_USER = "FETCH_COOKIE_USER";
export const FETCH_SESSION_USER = "FETCH_SESSION_USER";
export const FETCH_DIGITAL_ASSAYS_USER = "FETCH_DIGITAL_ASSAYS_USER";
export const SESSION_ERROR = "SESSION_ERROR";

const setHeaders = {
  pragma: "no-cache",
  "Content-Type": "application/json",
};

export function handleErrors() {
  return (dispatch) => {
    dispatch({ type: FETCH_SESSION_USER, payload: false });
  };
}

export function fetchDigitalAssaysUser(sessionPayload, cookiePayload) {
  return (dispatch) => {
    const webUserName =
      sessionPayload && sessionPayload.data && sessionPayload.data.webUserName;
    const encryptedUserName = encodeURIComponent(encrypt(webUserName));

    return new Promise((resolve, reject) => { return axios
      .get(`${USERAPI}/%27${encryptedUserName}%27`, setHeaders)
      .then((resp) => {
        dispatch({ type: FETCH_SESSION_USER, payload: sessionPayload });
        dispatch({ type: FETCH_COOKIE_USER, payload: cookiePayload });
        dispatch({
          type: FETCH_DIGITAL_ASSAYS_USER,
          payload: resp.data.data.userUuid,
        });
        resolve(resp);
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.status &&
          err.response.status === 404
        ) {
          return axios
            .post(USERAPI, { username: webUserName }, setHeaders)
            .then(() => {
              return axios
                .get(`${USERAPI}/%27${encryptedUserName}%27`, setHeaders)
                .then((resp) => {
                  dispatch({
                    type: FETCH_SESSION_USER,
                    payload: sessionPayload,
                  });
                  dispatch({ type: FETCH_COOKIE_USER, payload: cookiePayload });

                  dispatch({
                    type: FETCH_DIGITAL_ASSAYS_USER,
                    payload: resp,
                  });
                  resolve(resp);
                })
                .catch((err) => dispatch(handleErrors(err)));
            })
            .catch((err) => {
              if (err && err.response && err.response.status === 422) {
                dispatch({
                  type: SESSION_ERROR,
                  err: "Username is required! Login Again !! ",
                });
                
              }
              dispatch(handleErrors(err));
              reject(err);
            });
        }
      })})


  };
}

export function fetchSession() {
  return (dispatch) => {
    return new Promise ((resolve, reject)=> {
      return axios
      .get(`${config.ENDPOINTS.session}/sessionUser`, setHeaders)
      .then((resp) => {
        dispatch(fetchCookies(resp));
        resolve(resp);
      })
      .catch((err) => {
        dispatch(handleErrors(err));
        reject(err);
      });
    })
    
  };
}

export function fetchCookies(sessionPayload) {
  return (dispatch) => {
    return new Promise((resolve, reject) =>{
      return axios
      .get(`${config.ENDPOINTS.session}/fetchCookies`, setHeaders)
      .then((resp) => {
        dispatch(fetchDigitalAssaysUser(sessionPayload, resp)).then((resp)=>{resp && resolve()}).catch(err => err && reject(err));
      })
      .catch((err) => {
        dispatch(handleErrors(err));
        reject(err)
      });

    }) 
  };
}

export function fetchUserDetail() {
  return (dispatch) => {
    new Promise((resolve, reject) =>{
      if (config.ISLOCALHOST) {
        dispatch({ type: FETCH_SESSION_USER, payload: sessionUser });
        dispatch({
          type: FETCH_DIGITAL_ASSAYS_USER,
          payload: digitalAssaysUser.data.data.userUuid,
        });
        resolve()
      } else {
        dispatch(fetchSession()).then(resp => resp && resolve(resp)).catch(err => err && reject(err));
        
      }

    })
    
  };
}
